// @description: for new blog post body
import React from 'react'
import Seo from './components/Seo'
import Tracking from './components/Tracking'
import { Background } from './components/background'
import { BlogPostBodyInterface } from 'common/types/entities/blog-post-body-interface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { mimeTypes } from 'client/constants/editorSettings'
import { useBlogPost, usePage } from 'client/store'
import { getFirstEntityByType } from 'client/store/page/pageSelectors'
import BlogPostSettingsOld from './BlogPostSettings'
import { FileUpload } from '../components'
import { getSeo } from 'client/reducers/pageReducer'
import { updateSeoProperty } from 'client/store/page/pageActions'
import { getBlogPostImage } from 'client/store/blogPost/blogPostReducer'
import { useAppDispatch } from 'client/hooks/use-dispatch'

export const BlogPostSettingsResolver = () => {
  const isMigratedBodyEntity = usePage(page =>
    getFirstEntityByType(page, EntityTypeEnum.BlogPostBody),
  )

  if (isMigratedBodyEntity) {
    return <BlogPostSettings />
  }
  return <BlogPostSettingsOld />
}

export const BlogPostSettings = () => {
  const dispatch = useAppDispatch()
  const seo = usePage(getSeo)
  const blogPostImage = useBlogPost(getBlogPostImage)
  return (
    <>
      <Background<BlogPostBodyInterface> />
      <Seo
        fileUpload={
          <FileUpload
            fileId={undefined} // NOTE: to fix typescript error
            mimeTypes={mimeTypes.image}
            fileName={seo.socialImage || blogPostImage?.name}
            afterUpload={file =>
              dispatch(updateSeoProperty('socialImage')(file.id))
            }
            removeFile={
              seo.socialImage
                ? () => dispatch(updateSeoProperty('socialImage')(null))
                : null
            }
            label="page_settings.seo.social_image.label"
          />
        }
      />
      <Tracking />
    </>
  )
}
